// extracted by mini-css-extract-plugin
export default {"header":"Header_header__27WmH","container":"Header_container__raGll","text":"Header_text__w34NW","link":"Header_link__seXX0"};